import { handleAPI, API_VERSION_ONE_ADMIN } from '../../itrust_common/utils/apiUtils';

export function countriesLoad(filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/global_pricings/`
  const method = "GET"
  return {
    type: 'COUNTRIES_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function countryLoad(id, filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/global_pricings/${id}`
  const method = "GET"
  return {
    type: 'COUNTRY_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function countryCreate(data, filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/global_pricings/`
  const method = "POST"
  return {
    type: 'COUNTRY_CREATE',
    payload: handleAPI(url, filters, method, { global_pricing: data }),
  };
}

export function countryUpdate(data, filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/global_pricings/${data.id}`
  const method = "PUT"
  return {
    type: 'COUNTRY_UPDATE',
    payload: handleAPI(url, filters, method, { global_pricing: data })
  };
}

export function countryEdit(data) {
  return {
    type: 'COUNTRY_EDIT',
    payload: data,
  };
}

export function countryEditCancel() {
  return {
    type: 'COUNTRY_EDIT_CANCEL'
  };
}
